module.exports = __webpack_public_path__ + "static/media/hand-plant-icon.3100fa27.svg";